import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminSearchFilter.css';

const SearchFilter = ({ onFilter }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Debounce the search to avoid calling onFilter on every keystroke
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onFilter) {
    onFilter(searchTerm);
      }
    }, 300); // 300ms delay

    return () => clearTimeout(timer);
  }, [searchTerm, onFilter]);

  const handleSearchChange = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  return (
    <div className="search-filter">
      <div className="search-bar">
        <div className="search-button">
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search by ID or Name..."
          className="search-input"
        />
      </div>
    </div>
  );
};

export default SearchFilter;
